import type { MonthlyFeeSavePayload } from "gsintegrations";
import type { FormChatState } from "../repositories/formChat.repository";

/** Maps the confirmed chat state to the PUT /terreiro/:id/monthly-fees/:monthlyFeeId body; null when incomplete. */
export const buildMonthlyFeeSavePayload = (
  state: FormChatState,
  monthlyFeeId: string,
): MonthlyFeeSavePayload | null => {
  const { monthlyFee, dueDay, paymentMethod, receivingAccountId } = state;
  if (
    !monthlyFeeId ||
    typeof monthlyFee !== "number" ||
    !Number.isFinite(monthlyFee) ||
    monthlyFee < 0 ||
    typeof dueDay !== "number" ||
    !Number.isInteger(dueDay) ||
    dueDay < 1 ||
    dueDay > 31 ||
    !paymentMethod ||
    !receivingAccountId
  ) {
    return null;
  }
  return {
    id: monthlyFeeId,
    monthlyFee,
    dueDay,
    paymentMethod,
    receivingAccountId,
  };
};
